import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { postApiAction } from "../../Utils/helper";
import { BASE_URL } from '../../constants';

const CartEditPopup = ({ cartData, onClose, onUpdateComment  }) => {
  console.log("cartData", cartData);
  const bannerStyle = {
    backgroundImage: `url(${BASE_URL}/assets/images/editarBg.png)`,
  };

  const [comment, setComment] = useState(cartData?.notes);
  const [error, setError] = useState('');
  const handleCommentChange = (event) => {
    setComment(event.target.value);
    onUpdateComment(event.target.value);
  };
  const dispatch = useDispatch();

  const updateCart = async () => {
    let postData = {
        product_id: cartData.product.id,
        quantity: cartData.quantity,
        notes: comment
    }
    let resp = await postApiAction("cart/update", postData, 0, dispatch);
    if(resp?.response?.data?.message){
      setError(resp.response.data.message)
    }else{
      onClose()
      setError('')
      console.log('updateCart',postData)
    }
  }
  
  return (
    <>
      <div
        className="modal fade editarContentPart show show-popup"
        id="editarPopup"
      >
        <div className="modal-dialog">
          <div className="modal-content" style={bannerStyle}>
            <div className="modal-header">
              <h3 className="modal-title">Editar platillo</h3>
              <button
                onClick={onClose}
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body">
              <h3>{cartData.product.name}</h3>
              <div className="image">
                <img src={cartData.product.default_image} alt="" />
              </div>
              <div className="text">
                <p>{cartData.product.description}</p>
              </div>
              <div className="form-grrop">
                <textarea
                  name=""
                  id=""
                  className="text_coment form-control"
                  placeholder="Comentarios adicionales"
                  value={comment}
                  onChange={handleCommentChange}
                ></textarea>
                <div className="error">{error}</div>
              </div>
            </div>

            <div className="modal-footer footerSite">
              <div className="botton_group mt-0 d-flex flex-wrap justify-content-between">
                <button
                  onClick={onClose}
                  className="btn cancelBtn"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
                <button onClick={updateCart} className="btn ConfirmBtn">
                  Actualizar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CartEditPopup;
